import { render, staticRenderFns } from "./MarketSecond.vue?vue&type=template&id=f57f35e6&scoped=true"
import script from "./MarketSecond.vue?vue&type=script&lang=js"
export * from "./MarketSecond.vue?vue&type=script&lang=js"
import style0 from "./MarketSecond.vue?vue&type=style&index=0&id=f57f35e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57f35e6",
  null
  
)

export default component.exports